import { HStack, Text } from 'native-base';
import React from 'react';

import MapPinOutline from 'app/components/icons/MapPinOutline';
import TicketSelection from 'app/components/icons/TicketSelection';
import ReservationDetail, {
  ReservationDetailProps,
} from 'app/components/ReservationSummary/ReservationDetail';
import TextLabel from 'app/components/ReservationSummary/TextLabel';
import { IconComponent } from 'app/hocs/withIconWrapper';
import { ReservationOption } from 'app/services/GuestCenterService.types';
import { ReservationTextHelper } from 'app/services/I18n';

const optionTypeIcons: Record<string, IconComponent> = {
  location: MapPinOutline,
  admission: TicketSelection,
};

export type ReservationDetailOptionProps = Omit<ReservationDetailProps, 'Icon'> & {
  rt: ReservationTextHelper;
  option?: Maybe<ReservationOption>;
  optionType?: Maybe<string>;
  title?: string;
  layout?: 'vertical' | 'horizontal';
  isMuted?: boolean;
};

export default function ReservationDetailOption({
  option,
  rt,
  optionType,
  layout = 'vertical',
  title: $title,
  isMuted,
  _icon,
  ...props
}: ReservationDetailOptionProps) {
  const Icon = optionTypeIcons[option?.optionType ?? optionType ?? 'admission'] ?? TicketSelection;
  const title = $title ?? (option?.contentKey ? rt(`${option?.contentKey}_title`) : '');

  if (layout === 'horizontal') {
    return (
      <HStack alignItems="center" space="2">
        <Icon color="white" size={20} {..._icon} />
        <Text color="white">{title}</Text>
      </HStack>
    );
  }

  return (
    <ReservationDetail Icon={Icon} _icon={_icon} testID="ReservationDetailOption" {...props}>
      <TextLabel isMuted={isMuted}>{title}</TextLabel>
      {!title && <TextLabel />}
    </ReservationDetail>
  );
}
